import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    primary: '#EA7C69',
    primaryDark: '#e8654f',
    white: '#fff',
    dark: '#3B5162',
    gray: '#889898',
    light: '#ABBBC2',
    lighter: '#E0E6E9',
    darkLine: '#393C49',
    strongDarkBg: '#1F1D2B',
    strongDarkBgHover: '#403E4F',
    darkBg: '#252836',
    formBg: '#2D303E',
    green: '#50D1AA',
    red: '#FF7CA3',
    orange: '#FFB572',
    blue: '#65B0F6',
  },
};

export { theme };
